import { Theme } from '@mui/material/styles'
import { mode } from 'template/material-theme'

interface options {
  switch?: boolean
  small?: boolean
}

const dsgvoStyle = (
  theme: Theme,
  options?: options,
) => {
  const darkMode = mode === 'dark'

  let style: Record<string, unknown> = {
    padding: theme.spacing(1.25),
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 8,
    boxShadow: '0 8px 22px rgba(15, 23, 42, .04)',

    backgroundColor: darkMode
      ? theme.palette.background.paper
      : 'var(--page-builder-surface, rgba(255, 255, 255, .72))',
  }

  // Small
  if (options?.small !== false) style = {
    ...style,
    
    fontSize: '0.86rem',
    '& p': {
      fontSize: '0.86rem',
      margin: 0,
    },
  }

  // Switch
  if (options?.switch) style = {
    ...style,
    
    display: 'grid',
    gridGap: theme.spacing(2),
    gridTemplateColumns: 'min-content 1fr',
    alignItems: 'top',
  }

  return style
}

export default dsgvoStyle
